import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import Select from "react-select";
import ReactPaginate from "react-paginate";
import { MdVisibility, MdEdit } from "react-icons/md";
import { BiExport, BiImport } from "react-icons/bi";
import { toast } from "react-toastify";
import airConsolidationService from "../../../Services/airConsolidationService";
import { ChangeStatus } from "../../../Components";
import Loader from "../../../Components/Loader";
import locationServices from "../../../Services/locationServices";

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;
let currentPage1 = 1;
export const AirConsolidationRateList = () => {
  const [airConsolRateList, setAirConsolRateList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [countryList, setCountryList] = useState([]);
  const [countryValue, setCountryValue] = useState("");

  const history = useHistory();
  const imgRef = useRef();

  useEffect(() => {
    getCountryList();
  }, []);

  useEffect(() => {
    getAirConsolRateList();
  }, [currentPage]);

  const getCountryList = () => {
    let param = { page: 1, limit: 300 };
    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        let arry = [];
        arry.push({ value: "", label: "All country" });
        res.data.map((list) => {
          arry.push({ value: list.country_name, label: list.country_name });
        });
        setCountryList(arry);
      }
    });
  };

  const getAirConsolRateList = (
    countryId = countryValue ? countryValue.label : ""
  ) => {
    let param = { ...pagination, page: currentPage };
    if (pagination.search) {
      param["search"] = pagination.search;
      param["page"] = currentPage;
    }
    if (countryId) {
      param["page"] = currentPage;
      param["country"] = countryId;
    }

    airConsolidationService.get_cons_airfreightrats(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setAirConsolRateList(res.data);
        setPagination({ ...pagination, ...res.pagination });
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      airfreightrats_id: isModalOpen._id,
      airfreight_status:
        isModalOpen.airfreight_status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    airConsolidationService
      .update_cons_airfreightrats_status(postData)
      .then((res) => {
        if (res.status) {
          setIsModalOpen(false);
          getAirConsolRateList();
        }
      });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const onSelectCountry = (e) => {
    setCountryValue(e);
    getAirConsolRateList(e.value);
    setCurrentPage(1);
  };

  const onClickExport = () => {
    setLoader(true);
    airConsolidationService.export_airfreightrats_cons_data().then((res) => {
      if (res.status === true) {
        window.location.href = REACT_APP_API_BASEURL + "/" + res.data;
        toast.success("file download successfully");
        setLoader(false);
        getAirConsolRateList();
      } else {
        toast.error(res.message);
        setLoader(false);
      }
    });
  };


  const onClickImport = (e) => {
    setLoader(true);
    const formData = new FormData();
    formData.append("csv_file", e.target.files[0]);
    airConsolidationService
      .import_airfreightrats_cons_data(formData)
      .then((res) => {
        if (res.status) {
          toast.success("file upload successfully");
          setLoader(false);
          getAirConsolRateList();
          //   window.location.reload();
        } else {
          toast.error(res.message);
          setLoader(false);
        }
      });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="d-flex justify-content-between mb-3">
                <div>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        height: "calc(2.15rem + 2px)",
                        overflowY: "visible",
                      }),
                      control: (provider) => ({
                        ...provider,
                        width: "200px",
                        boxShadow: "0 0 0 0px #f46a6a",
                      }),
                      placeholder: (provider) => ({
                        ...provider,
                        color: "#a0b0ca",
                      }),
                    }}
                    placeholder="Search with country..."
                    value={countryValue}
                    onChange={(e) => onSelectCountry(e)}
                    options={countryList}
                  />
                </div>
                <div className="input-group pl-3 mx-2">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="search by port.."
                    onChange={(e) =>
                      setPagination({ ...pagination, search: e.target.value })
                    }
                    onKeyPress={(e) =>
                      e.key === "Enter" && getAirConsolRateList()
                    }
                    onKeyUp={(e) =>
                      e.key === "Backspace" &&
                      pagination.search.length <= 0 &&
                      getAirConsolRateList()
                    }
                  ></input>
                  <div className="input-group-prepend">
                    <button
                      className="input-group-text pointer search-btn"
                      onClick={() => getAirConsolRateList()}
                      style={{ backgroundColor: "#e5e4ec" }}
                    >
                      search
                    </button>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end mb-3">
                <div>
                  <input
                    type="file"
                    id="upload"
                    accept=".csv"
                    hidden
                    onChange={(e) => onClickImport(e)}
                  />
                  <label
                    for="upload"
                    className="btn btn-danger waves-effect waves-light mx-1 my-0"
                  >
                    <BiExport />
                    Upload File
                  </label>
                </div>
                <button
                  className="btn btn-success waves-effect waves-light mx-1 my-0"
                  onClick={() => onClickExport()}
                >
                  <BiImport />
                  Download File
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light mx-3 my-0"
                  onClick={() => history.push("/add-air-consolidation-rate")}
                >
                  Add AirFreightRates
                </button>
              </div>
              <input ref={imgRef} type="file" className="d-none" />
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    {/* <th>Origin city</th> */}
                    {/* <th>Origin country</th> */}
                    <th>
                      Destination <br />
                      country
                    </th>
                    <th>
                      Destination <br />
                      Port
                    </th>
                    <th>
                      Minimum <br />
                      CBM
                    </th>
                    {/* <th>Minimum <br />amount <small>(AED)</small> </th> */}
                    <th>
                      Normal <br />
                      amount <br />
                      <small>(AED)</small>
                    </th>
                    <th> + 45</th>
                    <th>+ 100</th>
                    <th>+ 250</th>
                    <th> + 500</th>
                    <th> + 1000</th>
                    <th>Fuel</th>
                    <th>Port tt</th>
                    <th>Door tt</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {airConsolRateList.length > 0 &&
                    airConsolRateList.map((item, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        {/* <td>{item.origin_city_name}</td> */}
                        {/* <td>{item.origin_country_name}</td> */}
                        <td>{item.destination_country_name}</td>
                        <td>{item.destination_city_name}</td>
                        <td>{item.minimum_amount}</td>
                        <td>{item.normal_amount}</td>
                        <td>{item.amount_greater_than_45}</td>
                        <td>{item.amount_greater_than_100}</td>
                        <td>{item.amount_greater_than_250}</td>
                        <td>{item.amount_greater_than_500}</td>
                        <td>{item.amount_greater_than_1000}</td>
                        <td>{item.fuel}</td>
                        <td>{item.port_delivery_tt}</td>
                        <td>{item.door_delivery_tt}</td>

                        <td>
                          <span
                            className={
                              "badge rounded-pill font-size-12 pointer" +
                              (item.airfreight_status === "ACTIVE"
                                ? " bg-success"
                                : " bg-soft-danger")
                            }
                            onClick={() => setIsModalOpen(item)}
                          >
                            {item.airfreight_status}
                          </span>
                        </td>
                        <td>
                          <MdEdit
                            className="pointer"
                            onClick={() =>
                              history.push(
                                "/edit-air-consolidation-rate?id=" + item._id,
                                item
                              )
                            }
                            color="#0323fe"
                            size="25px"
                          />
                          {/* <MdVisibility
                                                    className="pointer"
                                                    onClick={() => history.push('/air-freight-rate-details?id=' + item._id, item)}
                                                    color="#0323fe"
                                                    size="25px"
                                                /> */}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {airConsolRateList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {airConsolRateList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src="assets/images/prev.svg"
                    height={15}
                    alt="not found"
                  />
                }
                forcePage={currentPage - 1}
                nextLabel={
                  <img
                    src="assets/images/next.svg"
                    height={15}
                    alt="not found"
                  />
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          <Loader isShow={loader} />
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${isModalOpen.airfreight_status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
              } status ?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
